<template>
	<div class="bg-[#F6F8FA]">
		<Header :current="0"></Header>
		<div class="2xl:max-w-7xl xl:max-w-7xl mx-auto mb-[100px]">
			<div class="banner mb-[20px]">
				<el-carousel height="263px" class="" style="width:100%;" arrow="always" :autoplay="false">
					<el-carousel-item v-for="(item,index) in bannerList" :key="index">

						<el-image class="w-full h-full" :src="item.image" fit="cover"></el-image>
					</el-carousel-item>
				</el-carousel>
			</div>
			<div class="bg-white mb-[20px] py-[20px] px-[60px] box-border flex flex-wrap">
				<div @click="selectNav(0)" :class="navValue==0?'text-white bg-[#2979FF] rounded-[50px]':''"
					class="leading-[23px] cursor-pointer text-[14px] mr-[10px] px-[12px]">
					{{langInfo.class_all}}
				</div>
				<div @click="selectNav(item.id)" :class="navValue==item.id?'text-white bg-[#2979FF] rounded-[50px]':''"
					class="leading-[23px] cursor-pointer text-[14px] mr-[10px] px-[12px]" v-for="(item,index) in navList"
					:key="index">
					{{item.title}}
				</div>
			</div>
			<div class="bg-white">
				<div v-if="communityList.length>0&&isFinish" class="  py-[20px] box-border pb-[80px]">
					<div class="grid grid-cols-2 gap-[16px] mb-[105px]">
						<router-link :to="{path:'/QAZoneDetail',query: { id: item.id }}"
							v-for="(item,index) in communityList" :key="index"
							class="bg-[#F7F9FC] no-underline flex flex-col justify-between h-[225px] rounded-[5px] pt-[18px]  pb-[16px] pl-[10px] pr-[20px] box-border">
							<div class="">
								<div class="flex justify-between mb-7 ">
									<img class="w-[24px] h-[24px] mr-[9px]" src="@/static/image/icon07.png" alt=""
										srcset="" />
									<div class="text-[16px] text-[#000000] yw-text-cut-1"
										style="width: calc(100% - 34px);">
										{{item.title}}
									</div>
								</div>
								<div class="flex justify-between  ">
									<img class="w-[24px] h-[24px] mr-[9px]" src="@/static/image/icon08.png" alt=""
										srcset="" />
									<div class="text-[16px] text-[#000000]" style="width: calc(100% - 34px);">
										{{item.subtitle}}
									</div>
								</div>
							</div>
							<div class="text-[#9199A1]  text-right">{{item.create_time}}</div>
						</router-link>
					</div>
					<div class="flex justify-center">
						<el-pagination :page-size="pageSize" :total="total" :current-page="currentPage"
							@current-change="currentChange" background layout="prev, pager, next">
						</el-pagination>
					</div>
				</div>
				<emptyPage v-else-if="isFinish&&communityList.length==0" :title="langInfo.no_data_available">
				</emptyPage>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header.vue'
	import Footer from '@/components/Footer.vue'
	import emptyPage from '@/components/emptyPage.vue'
	export default {
		components: {
			Header,
			Footer,
			emptyPage
		},
		data() {
			return {
				bannerList: [],
				navValue: 0,
				navList: [],
				isFinish: false,
				pageSize: 8, //每页显示条目个数
				total: 0,
				currentPage: 1,
				communityList: [],
				langInfo: {}
			}
		},
		mounted() {
			this.get_community_classify()
			this.get_community_list()
			this.get_banner_list()

			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			} else {
				document.title = this.langInfo.pc_name+'-'+this.langInfo.QA_Zone;
			}

		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					document.title = this.langInfo.pc_name+'-'+this.langInfo.QA_Zone;
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			get_banner_list() {
				this.$api.bannerList({
					mark: 'community'
				}).then((res) => {

					console.log(res);
					this.bannerList = res.data.list_class
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 选择分类
			selectNav(type) {
				this.navValue = type
				this.isFinish = false
				this.currentPage = 1
				this.communityList = []
				this.get_community_list()
			},
			currentChange(e) {
				console.log(e);
				this.currentPage = e
				this.isFinish = false
				this.communityList = []
				this.get_community_list()
			},
			get_community_classify() {
				this.$api.community_classify({}).then((res) => {
					console.log("问答专区分类=====");
					console.log(res);
					this.navList = res.data
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			get_community_list() {
				this.$api.community_list({
					page: this.currentPage,
					limit: this.pageSize,
					community_classify_id: this.navValue > 0 ? this.navValue : ''
				}).then((res) => {
					console.log("问答专区列表=====");
					console.log(res);
					this.communityList = res.data.list
					this.isFinish = true
					this.total = res.data.total
				}).catch((error) => {
					this.isFinish = true
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
		}
	}
</script>

<style scoped>
	.banner {
		height: 263px;
		background: linear-gradient(180deg, rgba(110, 175, 247, 1) 0%, rgba(112, 176, 247, 0.64) 0%, rgba(120, 179, 248, 0.11) 34%, rgba(255, 255, 255, 0.11) 100%);
	}
</style>